import { type Document } from '../../../store/slices/documentSlice'
export const checkIsHaveEmiratesAndExpires = (agentDocs: Document[] , forClient? : boolean): { expireFile: string; file: Document | null } => {
    let expireFile = '';
    let file: Document | null = null;

 
 
    if (agentDocs.length > 0) {

        const validDocs = agentDocs.filter(doc => 
            doc?.attributes?.Type?.[0]?.__component === 'documents.emirates-id' &&
            doc?.attributes?.Statuses?.length > 0 &&  doc?.attributes?.Statuses?.[0] !== 'Archived' &&
            doc?.attributes?.LinkFront &&
            doc?.attributes?.LinkBack // && doc?.attributes?.ExpiryDate
        );

        const archivedDocs = agentDocs.filter(doc => 
            doc?.attributes?.Type?.[0]?.__component === 'documents.emirates-id' &&
            doc?.attributes?.Statuses?.length > 0 &&
            doc?.attributes?.Statuses?.[0] === 'Archived' &&
            doc?.attributes?.LinkFront &&
            doc?.attributes?.LinkBack // && doc?.attributes?.ExpiryDate
        );

        file = validDocs.reduce<Document | null>((prevDoc, currentDoc) => {
            return (prevDoc == null) || new Date(currentDoc.attributes.updatedAt) > new Date(prevDoc.attributes.updatedAt)
                ? currentDoc
                : prevDoc;
        }, null);
      

        if (file == null) {
            file = archivedDocs.reduce<Document | null>((prevDoc, currentDoc) => {
                return (prevDoc == null) || new Date(currentDoc.attributes.updatedAt) > new Date(prevDoc.attributes.updatedAt)
                    ? currentDoc
                    : prevDoc;
            }, null);
        }

        if (file != null) {
            expireFile = file.attributes.ExpiryDate || 'Expire not scanned';
        }
    }
   
    return { expireFile, file };
};

export const checkIsHavePassportAndExpires = (agentDocs: Document[]): any => {
    let expireFile = ''
    let file = null
    file = Array.isArray(agentDocs) && agentDocs.length > 0
        ? agentDocs.reduce((prevDoc: Document | null, currentDoc: Document) => {
            const currentDocStatus = currentDoc?.attributes?.Statuses?.[0];
            const prevDocType = prevDoc?.attributes?.Type?.[0]?.__component
            const currentDocType = currentDoc?.attributes?.Type?.[0]?.__component

            if (currentDocType === 'documents.passport' && currentDocStatus &&
                currentDocStatus !== 'Archived') {
                if (!prevDocType || new Date(currentDoc?.attributes?.updatedAt) > new Date(prevDoc?.attributes?.updatedAt)) {
                    expireFile = currentDoc?.attributes?.ExpiryDate || 'Expire not scanned';
                    return currentDoc
                }
            }
            return prevDoc
        }, null)
        : null
    return { expireFile, file }
}

export const checkIsHaveReraAndExpires = (agentDocs: Document[]): any => {
    let expireFile = ''
    let file = null

    file = Array.isArray(agentDocs) && agentDocs.length > 0
        ? agentDocs.reduce((prevDoc: Document | null, currentDoc: Document) => {
            const prevDocType = prevDoc?.attributes?.Type?.[0]?.__component
            const currentDocType = currentDoc?.attributes?.Type?.[0]?.__component
            const currentDocStatus = currentDoc?.attributes?.Statuses?.[0];

            if (currentDocType === 'documents.rera-card' && 
                currentDocStatus !== 'Archived') {
                if (!prevDocType || new Date(currentDoc?.attributes?.updatedAt) > new Date(prevDoc?.attributes?.updatedAt)) {
                    expireFile = currentDoc?.attributes?.ExpiryDate
                    return currentDoc
                }
            }

            return prevDoc
        }, null)
        : null

    return { expireFile, file }
}

export const checkIsHaveTradeAndExpires = (agentDocs: Document[]): any => {
    let expireFile = ''
    let file = null

    file = Array.isArray(agentDocs) && agentDocs.length > 0
        ? agentDocs.reduce((prevDoc: Document | null, currentDoc: Document) => {

            const prevDocType = prevDoc?.attributes?.Type?.[0]?.__component
            const currentDocType = currentDoc?.attributes?.Type?.[0]?.__component

            if (currentDocType === 'documents.trade-license') {
                if (!prevDocType || new Date(currentDoc?.attributes?.updatedAt) > new Date(prevDoc?.attributes?.updatedAt)) {
                    expireFile = currentDoc?.attributes?.ExpiryDate
                    return currentDoc
                }
            }
            return prevDoc
        }, null)
        : null
    return { expireFile, file }
}
export const checkIsHaveDeposit = (agentDocs: Document[]): any => {
    let file = null

    file = Array.isArray(agentDocs) && agentDocs.length > 0
        ? agentDocs.reduce((prevDoc: Document | null, currentDoc: Document) => {

            const prevDocType = prevDoc?.attributes?.Category
            const currentDocType = currentDoc?.attributes?.Category

            if (currentDocType === "Deposit Cheque") {
                if (!prevDocType || new Date(currentDoc?.attributes?.updatedAt) > new Date(prevDoc?.attributes?.updatedAt)) {
            
                    return currentDoc
                }
            }
            return prevDoc
        }, null)
        : null
    return { file }
}
export const checkIsHaveDraft = (agentDocs: Document[]): any => {
    let file = null

    file = Array.isArray(agentDocs) && agentDocs.length > 0
        ? agentDocs.reduce((prevDoc: Document | null, currentDoc: Document) => {

            const prevDocType = prevDoc?.attributes?.Category
            const currentDocType = currentDoc?.attributes?.Category

            if (currentDocType === "Draft Contract") {
                if (!prevDocType || new Date(currentDoc?.attributes?.updatedAt) > new Date(prevDoc?.attributes?.updatedAt)) {
                    return currentDoc
                }
            }
            return prevDoc
        }, null)
        : null
    return { file }
}
export const checkIsHaveUniversal = (agentDocs: Document[]): any => {
    let file = null

    file = Array.isArray(agentDocs) && agentDocs.length > 0
        ? agentDocs.reduce((prevDoc: Document | null, currentDoc: Document) => {
            const prevDocType = prevDoc?.attributes?.Category
            const currentDocType = currentDoc?.attributes?.Category
            if (currentDocType === "Offer Process Document") {
                if (!prevDocType || new Date(currentDoc?.attributes?.updatedAt) > new Date(prevDoc?.attributes?.updatedAt)) {
                    return currentDoc
                }
            }
            return prevDoc
        }, null)
        : null
    return { file }
}
